







































































import {
    MButton,
    MMessage,
    MPanel,
    MSpinner,
    MTextfield,
} from "@ulaval/modul-components";
import { Component, Vue } from "vue-property-decorator";
import BoutonsNavigation from "../components/BoutonsNavigation.vue";
import { INouvelleLocation, NouvelleLocation } from "../models/Location";
import DelaiLocationPlugin from "../plugins/delai";
import {
    Paysafe,
    PaysafeEnvironment,
    PaysafeOptions,
} from "../plugins/paysafe";
import router from "../router";
import store, { modules } from "../store";
import { IUtilisateurState } from "../store/models";

Vue.filter("formatDevise", function (montant: number) {
  return Intl.NumberFormat("fr-CA", {
    currency: "CAD",
    style: "currency",
  }).format(montant);
});

@Component({
  components: {
    MButton,
    MTextfield,
    MPanel,
    MSpinner,
    MMessage,
    BoutonsNavigation,
  },
})
export default class Paiement extends Vue {
  private erreur: string = "";

  private transactionEnCours: boolean = false;
  private informationBancaireValide: boolean = false;
  private numeroCarte: string = "";
  private dateExpiration: string = "";
  private cvv: string = "";
  private codePostal: string = "";
  private jetonPaysafe: string = "";

  private static cleAPI: string = process.env.VUE_APP_PAYSAFE_API_KEY || "";
  private static paysafeOptions: PaysafeOptions = {
    environment: (process.env.VUE_APP_PAYSAFE_ENV ||
      "TEST") as PaysafeEnvironment,
    fields: {
      cardNumber: {
        selector: "#numero-carte",
        placeholder: "Numéro de carte",
      },
      expiryDate: {
        selector: "#date-expiration",
        placeholder: "MM / AA",
      },
      cvv: {
        selector: "#cvv",
        placeholder: "CVV",
      },
    },
  };

  private async mounted(): Promise<void> {
    store.commit(modules.trainProgression.mutations.activerPrecedent.name);

    store.commit(modules.trainProgression.mutations.desactiverSuivant.name);

    await store.dispatch(modules.minuteur.actions.demarrerMinuteur.name, {
      delaiVerrou: this.delaiVerrou,
    });

    const surValidation = (informationBancaireValide: boolean): void => {
      this.informationBancaireValide = informationBancaireValide;
    };

    try {
      await Paysafe.configuration(
        Paiement.cleAPI,
        Paiement.paysafeOptions,
        surValidation
      );

      this.erreur = "";
    } catch (_) {
      this.erreur =
        "Une erreur est survenue lors de la configuration du système de paiement. Veuillez réessayer plus tard ou consultez la rubrique Aide si jamais le problème persiste.";
    }
  }

  get utilisateur(): IUtilisateurState {
    return store.state.utilisateur;
  }

  get montant(): number | null {
    return store.state.utilisateur.montant;
  }

  // TODO: Refactor (utilisé ailleurs)
  get delaiVerrou(): string | null {
    // Obtenir la clé de la définition de la variable d'environnement
    const definitionsVariable = store.state.cds.definitionsVariablesEnv.find(
      (definition) =>
        definition.nomVariableEnv ===
        store.state.applicatif.variableEnvCleDelaiVerrou
    );

    if (definitionsVariable !== undefined) {
      // Obtenir la valeur de la variable d'environnement pour le courriel
      const valeursVariable = store.state.cds.valeursVariablesEnv.find(
        (variableEnv) => variableEnv.definitionId === definitionsVariable.id
      );

      if (valeursVariable !== undefined) {
        return valeursVariable.valeur;
      }
    }

    return null;
  }

  public formulaireValide(): boolean {
    // Validation du code postal
    const regex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
    const match = regex.exec(this.codePostal);

    if (match && this.informationBancaireValide) {
      return true;
    } else {
      return false;
    }
  }

  public async payer(): Promise<void> {
    const isDelaiLocationDepasse = DelaiLocationPlugin.isDelaiLocationDepasse();
    store.state.utilisateur.isDelaiLocationDepasse = isDelaiLocationDepasse;

    if (!isDelaiLocationDepasse && this.formulaireValide()) {
      try {
        this.jetonPaysafe = await Paysafe.jeton();
        this.erreur = "";

        const detailsLocation: INouvelleLocation = {
          si_tps:
            this.utilisateur.periode?.tauxTPS &&
            this.utilisateur.typeClientele?.taxable
              ? this.utilisateur.periode.tauxTPS *
                this.utilisateur.periode.tarifLocation
              : 0,
          si_tvq:
            this.utilisateur.periode?.tauxTVQ &&
            this.utilisateur.typeClientele?.taxable
              ? this.utilisateur.periode.tauxTVQ *
                this.utilisateur.periode.tarifLocation
              : 0,
          si_total: this.utilisateur.montant,
          si_tariflocation: this.utilisateur.periode?.tarifLocation || 0,
          si_acceptationconditionslocation: true,
          si_adressedecourriel:
            this.utilisateur.courriel ||
            this.$msal.data.query.profile?.mail ||
            "",
          si_nomdulocateur: this.$msal.data.query.profile?.surname || "",
          si_prenomdulocateur: this.$msal.data.query.profile?.givenName || "",
          si_identifiant_locateur: this.$msal.data.query.profile?.id || "",
          typeClienteleId: this.utilisateur.typeClientele?.id || "",
          casierId: this.utilisateur.casier?.id || "",
          niveauId: this.utilisateur.niveau?.id || "",
          pavillonId: this.utilisateur.pavillon?.id || "",
          periodeId: this.utilisateur.periode?.id || "",
        };
        const nouvelleLocation = new NouvelleLocation(
          detailsLocation,
          this.codePostal,
          this.jetonPaysafe
        );

        this.transactionEnCours = true;

        await store.dispatch(modules.cds.actions.creerLocation.name, {
          vm: this,
          location: nouvelleLocation.serialiser(),
        });

        const route: string = await store.dispatch(
          modules.trainProgression.actions.etapeDepart.name
        );
        router.push({ name: route });

        // Une fois la location effectuée, le minuteur n'est plus nécessaire
        store.commit(modules.minuteur.mutations.arreterMinuteurSucces.name);
      } catch (err) {
        // Récupération de la réponse retournée par le plugin s'il y a lieu
        if (
          err.response &&
          err.response.data &&
          err.response.data.error &&
          err.response.data.error.message
        ) {
          this.erreur = err.response.data.error.message;
        } else {
          this.erreur =
            "Une erreur inconnue est survenue lors de la transaction. Veuillez réessayer plus tard ou consulter la rubrique Aide si jamais le problème persiste.";
        }
      }

      this.transactionEnCours = false;
    }
  }
}
